<template>
  <div id="app">
    <header class="app-header">
      <!-- 图片容器，增加悬浮动效 -->
      <div class="logo-container">
        <img class="logo-img" alt="Vue logo" src="./assets/合照.jpg">
      </div>

      <!-- 标题区域：改造成可爱风格 -->
      <h1 class="cute-header" @click="toggleViewMode">
        <!-- 给 Emoji 单独加个类名，做上下跳动动画 -->
        <span class="header-emoji">🎯</span>
        你今天开心嘛
      </h1>

      <!-- 副标题也可以带个波浪线点缀 -->
      <p class="subtitle">点击标题切换视图模式 <span class="wave">✨</span></p>
    </header>

    <main>
      <!-- 模式选择器 -->
      <div class="mode-selector">

        <button
            :class="{ active: currentMode === 'mood' }"
            @click="switchMode('mood')"
        >
          🎉 心情记录
        </button>
<!--        <button-->
<!--            :class="{ active: currentMode === 'welcome' }"-->
<!--            @click="switchMode('welcome')"-->
<!--        >-->
<!--          🏠 欢迎页面-->
<!--        </button>-->
        <button
            :class="{ active: currentMode === 'demo' }"
            @click="switchMode('demo')"
        >
          🎮 小互动
        </button>
        <button
            :class="{ active: currentMode === 'info' }"
            @click="switchMode('info')"
        >
          ℹ️ 项目信息
        </button>
      </div>

      <!-- 根据当前模式显示不同内容 -->
      <div class="content-area">
        <!-- 欢迎模式 -->
        <div v-if="currentMode === 'welcome'" class="mode-content welcome-mode">
          <HelloWorld msg="Vue.js App 启动成功！"/>

          <div class="features">
            <h3>✨ 项目特性</h3>
            <ul>
              <li>✅ Vue 2 + Vue Router + Vuex</li>
              <li>✅ 组件化开发</li>
              <li>✅ 响应式设计</li>
              <li>✅ 热重载开发体验</li>
            </ul>
          </div>
        </div>

        <!-- 演示模式 -->
        <div v-else-if="currentMode === 'demo'" class="mode-content demo-mode">
          <MyFirstComponent/>

          <!-- 颜色选择器示例 -->
          <div class="demo-card">
            <h4>颜色选择器</h4>
            <div class="color-picker">
              <div
                  v-for="color in colors"
                  :key="color"
                  :class="['color-option', { selected: selectedColor === color }]"
                  :style="{ backgroundColor: color }"
                  @click="selectColor(color)"
              ></div>
            </div>
            <p>当前颜色: <span :style="{ color: selectedColor }">{{ selectedColor }}</span></p>
          </div>

          <div class="extra-demos">
            <h3>🎯 更多示例</h3>

            <!-- 计数器示例 -->
            <div class="demo-card">
              <h4>简单计数器</h4>
              <div class="counter">
                <button @click="decrement">-</button>
                <span class="count">{{ counter }}</span>
                <button @click="increment">+</button>
              </div>
              <button @click="resetCounter" class="reset-btn">重置</button>
            </div>
          </div>
        </div>

        <!-- 心情记录 -->
        <div v-else-if="currentMode === 'mood'" class="mode-content mood-mode">
          <MoodTracker/>
        </div>

        <!-- 信息模式 -->
        <div v-else-if="currentMode === 'info'" class="mode-content info-mode">
          <div class="info-card">
            <h3>📊 项目信息</h3>
            <table class="info-table">
              <tr>
                <td>项目名称:</td>
                <td><strong>你今天开心嘛</strong></td>
              </tr>
              <tr>
                <td>开发环境:</td>
                <td>IntelliJ IDEA</td>
              </tr>
              <tr>
                <td>Vue 版本:</td>
                <td>2.6.14</td>
              </tr>
              <tr>
                <td>当前日期:</td>
                <td>{{ createdDate }}</td>
              </tr>
            </table>
          </div>

          <div class="quick-links">
            <h3>🔗 快速链接</h3>
            <div class="links">
              <button
                  :class="{ active: currentMode === 'mood' }"
                  @click="switchMode('mood')"
                  class="link-btn"
              >
                🎉 心情记录
              </button>
<!--              <router-link to="/" class="link-btn">🏠 首页</router-link>-->
<!--              <router-link to="/about" class="link-btn">📖 关于</router-link>-->
              <a href="#" @click.prevent="showMessage" class="link-btn">💬 弹出消息</a>
              <button @click="showTime" class="link-btn">🕐 显示时间</button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <footer class="app-footer">
      <div class="footer-content">
        <!-- 主要信息行 -->
        <p class="footer-line">
          <span class="footer-icon">🚀</span>
          使用 IntelliJ IDEA 开发 |
          当前视图: <span class="mode-indicator">{{ modeNames[currentMode] }}</span>
        </p>

        <p class="footer-line">
          <span class="footer-icon">🕒</span>
          当前时间：{{ currentTime }} |
          页面已加载 <span class="highlight">{{ loadCount }}</span> 次
        </p>

        <!-- 提示 -->
        <p class="footer-hint">
          <span class="footer-icon">💡</span>
          提示: 点击标题可以循环切换视图模式
        </p>

        <!-- 备案信息 -->
        <p class="footer-beian">
          <a
              href="http://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener"
              class="beian-link"
              title="点击查看工信部备案信息"
          >
            豫ICP备2026020340号
          </a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import MyFirstComponent from './components/MyFirstComponent.vue'
import MoodTracker from './components/MoodTracker.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    MyFirstComponent,
    MoodTracker
  },
  data() {
    return {
      currentMode: 'mood', // welcome, demo, info
      counter: 0,
      colors: ['#ff9eb3', '#42b983', '#3498db', '#e74c3c', '#f39c12', '#9b59b6'],
      selectedColor: '#ff9eb3',
      currentTime: '',
      loadCount: 0,
      createdDate: new Date().toLocaleDateString(),
      modeNames: {
        welcome: '欢迎模式',
        demo: '小互动',
        info: '项目信息',
        mood: '心情记录'
      }
    }
  },
  mounted() {
    console.log('🎉 App.vue 已挂载！')

    // 更新时间
    this.updateTime()
    this.timeInterval = setInterval(() => {
      this.updateTime()
    }, 1000)

    // 增加加载次数
    this.loadCount = parseInt(localStorage.getItem('vue_load_count') || 0) + 1
    localStorage.setItem('vue_load_count', this.loadCount.toString())
  },
  beforeDestroy() {
    // 清理定时器
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
    }
  },
  methods: {
    // 切换视图模式
    switchMode(mode) {
      this.currentMode = mode
      console.log(`切换到 ${this.modeNames[mode]} 模式`)
    },

    // 点击标题循环切换模式
    toggleViewMode() {
      const modes = ['mood', 'demo', 'info']
      const currentIndex = modes.indexOf(this.currentMode)
      const nextIndex = (currentIndex + 1) % modes.length
      this.currentMode = modes[nextIndex]

      // 显示切换动画提示
      this.showToast(`切换到 ${this.modeNames[this.currentMode]}`)
    },

    // 计数器方法
    increment() {
      this.counter++
    },
    decrement() {
      this.counter--
    },
    resetCounter() {
      this.counter = 0
      this.showToast('计数器已重置')
    },

    // 颜色选择
    selectColor(color) {
      this.selectedColor = color
      document.documentElement.style.setProperty('--primary-color', color)
    },

    // 显示消息
    showMessage() {
      alert(`🎉 恭喜你，点击了标题！\n当前模式: ${this.modeNames[this.currentMode]}`)
    },

    showTime() {
      alert(`当前时间: ${this.currentTime}`)
    },

    // 更新时间
    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleTimeString()
    },

    // 简单的 toast 提示
    showToast(message) {
      // 创建临时提示元素
      const toast = document.createElement('div')
      toast.className = 'toast-message'
      toast.textContent = message
      toast.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #42b983;
        color: white;
        padding: 10px 20px;
        border-radius: 5px;
        z-index: 1000;
        animation: fadeInOut 2s;
      `

      // 添加动画样式
      const style = document.createElement('style')
      style.textContent = `
        @keyframes fadeInOut {
          0% { opacity: 0; transform: translateY(-10px); }
          10% { opacity: 1; transform: translateY(0); }
          90% { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-10px); }
        }
      `

      document.head.appendChild(style)
      document.body.appendChild(toast)

      // 2秒后移除
      setTimeout(() => {
        toast.remove()
        style.remove()
      }, 2000)
    }
  }
}
</script>

<style>
/* CSS 变量，用于动态主题色 */
/* =========================================
   🎨 统一“可爱马卡龙”配色方案
   ========================================= */
:root {
  /* 1. 核心主色：蜜桃粉（从绿色改为粉色系） */
  --primary-color: #ff9eb3;        /* 温柔的珊瑚粉色 */
  --primary-light: #ffd6df;        /* 极浅粉色背景 */
  --primary-dark: #ff7eb3;         /* 深粉色用于 hover/点击 */
  --primary-gradient: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%); /* 渐变备用 */

  /* 2. 辅助色：马卡龙色盘 */
  --secondary-color: #fecfef;      /* 浅紫粉 */
  --accent-color: #a18cd1;         /* 梦幻紫（用于特殊点缀） */
  --highlight-color: #84fab0;      /* 清新薄荷绿（用于成功提示，对比色） */

  /* 3. 背景色：暖调奶油色（去掉了原本的冷蓝灰） */
  --bg-gradient-start: #fdfbf7;    /* 暖白 */
  --bg-gradient-end: #f3e7e9;      /* 淡淡的粉紫色，营造温馨氛围 */

  /* 4. 文字颜色：稍微偏暖的深灰，比纯黑更亲和 */
  --text-color: #4a4a4a;
  --text-light: #8e8e8e;

  /* 5. 界面元素 */
  --card-bg: #ffffff;              /* 卡片纯白 */
  --border-color: #fce4ec;         /* 边框用极淡的粉色，而不是灰色 */

  /* 6. 阴影：用暖色阴影，代替冷色阴影 */
  --shadow-sm: 0 4px 12px rgba(255, 158, 179, 0.1);  /* 粉色系阴影 */
  --shadow-hover: 0 8px 24px rgba(255, 158, 179, 0.25);

  --transition-speed: 0.3s;
  --border-radius: 16px;           /* 圆角稍微加大，更圆润 */
}

/* ==================== 全局背景重置 ==================== */
#app {
  /* 去掉原来的冷色渐变，换成暖色渐变 */
  background: linear-gradient(120deg, var(--bg-gradient-start) 0%, var(--bg-gradient-end) 100%);
  color: var(--text-color);
}

/* ==================== 按钮与交互元素适配 ==================== */

/* 模式选择器按钮：未选中时改用淡灰边框，选中时用粉色 */
.mode-selector button {
  border-color: #eecbd3; /* 淡粉边框 */
  color: var(--text-color);
}

.mode-selector button:hover {
  border-color: var(--primary-color);
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
}

.mode-selector button.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
  box-shadow: 0 4px 15px rgba(255, 158, 179, 0.4);
}

/* 提示框（Toast）颜色 */
.toast-message {
  background: var(--primary-color) !important; /* 覆盖内联样式 */
}

/* 头部样式 */
.app-header {
  display: flex;
  flex-direction: column; /* 严格垂直排列 */
  align-items: center;    /* 水平居中 */
  justify-content: center;
  margin-bottom: 60px;    /* 下方留出大空白，不拥挤 */
  padding-top: 20px;
}

/* --- 图片样式 --- */
.logo-container {
  margin-bottom: 25px; /* 图片与标题的间距加大 */
  position: relative;
}

.logo-img {
  width: 140px;         /* 图片放大到 140px，视觉冲击力更强 */
  height: 140px;        /* 强制正方形 */
  object-fit: cover;    /* 裁剪图片保持比例不拉伸 */
  border-radius: 50%;   /* 强制圆形 */
  border: 5px solid rgba(255, 255, 255, 0.8); /* 内圈白边 */
  box-shadow:
      0 10px 25px rgba(66, 185, 131, 0.25),  /* 柔和的绿色投影 */
      0 0 0 1px rgba(66, 185, 131, 0.1);      /* 极细的外圈描边 */
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1); /* 弹性悬浮动画 */
}

/* 鼠标悬停时的图片效果 */
.logo-img:hover {
  transform: scale(1.1) rotate(3deg);
  box-shadow:
      0 15px 35px rgba(66, 185, 131, 0.35),
      0 0 0 1px rgba(66, 185, 131, 0.2);
}

.cute-header {
  /* 字体设置：优先使用圆润字体，如果没有则用系统圆体 */
  font-family: 'Quicksand', 'Varela Round', 'YouYuan', 'Microsoft YaHei', sans-serif;

  /* 文字排版 */
  font-size: 3.2rem;      /* 字号稍微大一点，撑起气场 */
  font-weight: 900;       /* 特粗，为了做立体效果 */
  letter-spacing: 2px;
  text-align: center;
  margin: 0;
  margin-bottom: 15px;
  cursor: pointer;
  position: relative;

  /* --- 可爱核心：双层描边立体字效果 --- */
  color: #fff;           /* 文字本体设为白色 */
  text-shadow:
      3px 3px 0px #ff9eb5,  /* 第三层：粉色主描边 */
      6px 6px 0px rgba(255, 158, 181, 0.3), /* 第四层：粉色投影 */
      0px 8px 15px rgba(66, 185, 131, 0.15); /* 底部柔和阴影，增加悬浮感 */

  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  /* 保证点击时不出现蓝色背景框 */
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

/* 鼠标悬停效果：整体放大，描边加深 */
.cute-header:hover {
  transform: scale(1.05) translateY(-5px);
  text-shadow:
      4px 4px 0px #ff7eb3,  /* 悬停时描边变深一点 */
      8px 8px 0px rgba(255, 126, 179, 0.2),
      0px 12px 20px rgba(66, 185, 131, 0.25);
}

/* 点击时的按压效果 */
.cute-header:active {
  transform: scale(0.95) translateY(2px);
  text-shadow:
      2px 2px 0px #ff9eb5,
      0px 2px 5px rgba(0,0,0,0.1);
}

/* --- 标题中的 Emoji 动画 --- */
.header-emoji {
  display: inline-block;
  animation: bounce 2s infinite ease-in-out;
  margin-right: 5px;
  filter: drop-shadow(0 4px 0 rgba(0,0,0,0.1)); /* Emoji 也有立体感 */
}

@keyframes bounce {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-8px) rotate(10deg); }
}

/* --- 副标题改造：加点波浪装饰 --- */
.subtitle {
  margin: 0;
  font-family: 'Quicksand', sans-serif;
  font-size: 1.1rem;
  color: #8899a6;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.subtitle .wave {
  display: inline-block;
  animation: shake 2s infinite;
  font-size: 1.3rem;
}

@keyframes shake {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(15deg); }
  75% { transform: rotate(-15deg); }
}

/* 加载 Quicksand 字体（可选，如果不想要网络字体请求可删除） */
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@700&display=swap');

/* 模式选择器 */
.mode-selector {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.mode-selector button {
  padding: 12px 24px;
  border: 2px solid #ddd;
  background: white;
  border-radius: 25px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s;
  outline: none;
}

.mode-selector button:hover {
  border-color: var(--primary-color);
  transform: translateY(-2px);
}

.mode-selector button.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
  box-shadow: 0 4px 15px rgba(66, 185, 131, 0.3);
}

/* 内容区域 */
.content-area {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  min-height: 400px;
}

/* 不同模式的内容样式 */
.mode-content {
  animation: fadeIn 0.5s;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 欢迎模式 */
.welcome-mode {
  text-align: center;
}

.features {
  margin-top: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
}

.features ul {
  list-style: none;
  padding: 0;
  display: inline-block;
  text-align: left;
}

.features li {
  padding: 8px 0;
  font-size: 16px;
}

/* 演示模式 */
.demo-card {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
  margin: 20px 0;
  border-left: 4px solid var(--primary-color);
}

.counter {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 15px 0;
}

.counter button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: var(--primary-color);
  color: white;
  font-size: 20px;
  cursor: pointer;
}

.count {
  font-size: 24px;
  font-weight: bold;
  min-width: 50px;
  text-align: center;
}

.reset-btn {
  padding: 8px 16px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.color-picker {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin: 15px 0;
}

.color-option {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid transparent;
  transition: transform 0.3s;
}

.color-option:hover {
  transform: scale(1.2);
}

.color-option.selected {
  border-color: #333;
  transform: scale(1.1);
}

/* 信息模式 */
.info-card {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 25px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
}

.info-table tr {
  border-bottom: 1px solid #eee;
}

.info-table td {
  padding: 12px 0;
}

.info-table td:first-child {
  width: 120px;
  color: #7f8c8d;
}

.mode-badge {
  display: inline-block;
  padding: 4px 12px;
  background: var(--primary-color);
  color: white;
  border-radius: 12px;
  font-size: 12px;
}

.quick-links {
  text-align: center;
}

.links {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.link-btn {
  display: inline-block;
  padding: 10px 20px;
  background: var(--primary-color);
  color: white;
  text-decoration: none;
  border-radius: 25px;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
}

.link-btn:hover {
  background: #3aa876;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(66, 185, 131, 0.3);
}

/* 页脚 */
footer {
  text-align: center;
  margin-top: 40px;
  padding: 20px;
  color: #7f8c8d;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
}

.mode-indicator {
  font-weight: bold;
  color: var(--primary-color);
}

.hint {
  font-size: 0.9em;
  margin-top: 10px;
  opacity: 0.8;
}

/* ==================== 美化页脚 ==================== */

.app-footer {
  margin-top: 30px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px); /* 毛玻璃效果，现代感 */
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.6);
  font-size: 13px;
  color: #6c757d;
  text-align: center;
  transition: all 0.3s ease;
}

.app-footer:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

.footer-content {
  max-width: 600px;
  margin: 0 auto;
}

.footer-line {
  margin: 6px 0;
  color: #555;
  font-size: 14px;
}

.footer-icon {
  margin-right: 6px;
  font-size: 16px;
}

.mode-indicator {
  font-weight: 600;
  color: var(--primary-color);
  background: var(--primary-light);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 13px;
}

.highlight {
  font-weight: bold;
  color: var(--primary-color);
}

.footer-hint {
  margin: 10px 0;
  padding: 8px 15px;
  background: #e8f5e9;
  color: #2e7d32;
  border-radius: 10px;
  display: inline-block;
  font-size: 13px;
  border: 1px dashed var(--primary-color);
}

/* 备案信息 - 低调风格 */
.footer-beian {
  margin-top: 10px;
  font-size: 12px;
  color: #7a7a7a; /* 统一文字颜色 */
}

.beian-link {
  color: #7a7a7a; /* 柔和的灰色 */
  text-decoration: none;
  border-bottom: 1px dashed rgba(122, 122, 122, 0.3); /* 浅虚线，更含蓄 */
  transition: all 0.3s ease;
  font-weight: 400;
}

.beian-link:hover {
  color: #52c470; /* 悬停时变为温柔绿色，呼应主题 */
  border-bottom-style: solid;
  border-bottom-color: #52c470;
}

/* 响应式设计 */
@media (max-width: 768px) {
  header h1 {
    font-size: 1.8em;
  }

  .mode-selector {
    flex-direction: column;
    align-items: center;
  }

  .mode-selector button {
    width: 100%;
    max-width: 300px;
  }

  .content-area {
    padding: 15px;
  }

  .links {
    flex-direction: column;
    align-items: center;
  }

  .link-btn {
    width: 100%;
    max-width: 200px;
  }

  .app-footer {
    padding: 16px;
    font-size: 12px;
  }

  .footer-line {
    font-size: 12px;
  }

  .footer-hint {
    font-size: 12px;
    padding: 6px 10px;
  }

  .beian-link {
    font-size: 11px;
  }
}
</style>